export default "__VITE_ASSET__1e7934e1__"